import { useCallback, useEffect } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { listShipperAttachments } from '../use-cases/listShipperAttachments'

export function useShipperAttachments(shipperUUID: string) {
  const { call, result, status } = useAsync(listShipperAttachments)
  const abortController = useAbortController([shipperUUID])

  const fetchAttachments = useCallback(() => {
    call(shipperUUID, { signal: abortController.signal })
  }, [shipperUUID, call, abortController])

  useEffect(() => {
    fetchAttachments()
  }, [fetchAttachments])

  const attachments = result ?? []

  return {
    carrierDocuments: attachments.filter(a => a.uploadedBy === 'carrier'),
    shipperDocuments: attachments.filter(a => a.uploadedBy === 'shipper'),
    status,
    refetch: fetchAttachments,
  }
}
